import { resolveImagePath } from '@/utils/imageMap';

export function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-6xl mx-auto px-6">
        {/* Desktop Layout */}
        <div className="hidden md:grid md:grid-cols-3 md:gap-8 md:items-start">
          {/* Logo Section */}
          <div className="flex justify-center md:justify-start">
            <a href="/" className="block">
              <img 
                src={resolveImagePath("/images/centric-mx-logo.png")} 
                alt="Centric Aviation" 
                className="h-16 w-auto"
              />
            </a>
          </div>
          
          {/* Address Section */}
          <div className="text-center md:text-left">
            <h4 className="text-lg font-semibold mb-4">Address</h4>
            <a 
              href="https://maps.app.goo.gl/pE4FSLhRwxrmCBJv8"
              target="_blank"
              rel="noopener noreferrer"
              className="block text-gray-300 hover:text-white transition-colors duration-200"
            >
              Centric MX<br />
              Hangar 8 Airport Rd<br />
              Apalachicola FL 32320
            </a>
          </div>
          
          {/* Contact Section */}
          <div className="text-center md:text-left">
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <div className="space-y-4">
              <div>
                <h5 className="font-medium text-white mb-2">Phone:</h5>
                <a 
                  href="tel:8507450422"
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  (850) 745-0422
                </a>
              </div>
              <div>
                <h5 className="font-medium text-white mb-2">Email:</h5>
                <a 
                  href="mailto:brantley@centricmx.com"
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  brantley@centricmx.com
                </a>
              </div>
            </div>
          </div>
        </div>
        
        {/* Mobile Layout */}
        <div className="md:hidden space-y-8">
          {/* Logo */}
          <div className="flex justify-center">
            <a href="/" className="block">
              <img 
                src={resolveImagePath("/images/centric-mx-logo.png")} 
                alt="Centric Aviation" 
                className="h-16 w-auto"
              />
            </a>
          </div>
          
          {/* Address */}
          <div className="text-center">
            <a 
              href="https://maps.app.goo.gl/pE4FSLhRwxrmCBJv8"
              target="_blank"
              rel="noopener noreferrer"
              className="block text-gray-300 hover:text-white transition-colors duration-200"
            >
              Centric MX Hangar 8 Airport Rd Apalachicola FL 32320
            </a>
          </div>
          
          {/* Contact */}
          <div className="text-center space-y-4">
            <h4 className="text-lg font-semibold">Contact Us</h4>
            <div className="space-y-2">
              <div>
                <span className="font-medium">Phone: </span>
                <a 
                  href="tel:8507450422"
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  (850) 745-0422
                </a>
              </div>
              <div>
                <span className="font-medium">Email: </span>
                <a 
                  href="mailto:brantley@centricmx.com"
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  brantley@centricmx.com
                </a>
              </div>
            </div>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-gray-700">
          <div className="text-center">
            <span className="text-sm text-gray-400">
              Copyright © 2025 Centric Aviation LLC
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}